import { render, staticRenderFns } from "./serialNumberButton.vue?vue&type=template&id=5810890c&"
import script from "./serialNumberButton.vue?vue&type=script&lang=ts&"
export * from "./serialNumberButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports